import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

interface MarketingCtaProps {
  readonly title: string
  readonly body: string
  readonly buttonLabel: string
  /** Internal destination, e.g. "/" for sign-up or "/pricing". */
  readonly to: string
}

/**
 * Closing call-to-action block shared by every marketing content page. Uses a
 * plain <Link> (not the auth dialog) so it works during static prerender and
 * for crawlers — the target route handles sign-in.
 */
export function MarketingCta({ title, body, buttonLabel, to }: MarketingCtaProps) {
  return (
    <section className="mx-auto max-w-5xl px-6 py-20">
      <div className="glass-panel relative overflow-hidden rounded-3xl px-8 py-16 text-center">
        <div
          className="landing-ambient"
          style={{ top: '-30%', left: '20%', width: '300px', height: '300px' }}
          aria-hidden
        />
        <div className="relative">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">{title}</h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground sm:text-lg">{body}</p>
          <div className="mt-8 flex justify-center">
            <Link
              to={to}
              className="group inline-flex h-11 items-center gap-2 rounded-md bg-primary px-8 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 no-underline"
            >
              {buttonLabel}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
